import React from 'react';
import Joi from 'joi-browser';
import { validationByJoi } from '../utilities/commonValidation';
import regex from '../utilities/validateRegex';
import dialogLoader from '../utilities/dialogLoader';

import { FieldService } from '../services/Fields';
import { EditSuccess } from './modals/Commons';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';

export class TotalizeInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: sessionStorage.getItem('field_id'), // TODO
      formValues: {
        print_total_manual_operation: 0,
        total_workers_num: 0,
      },
      errors: {},
      editDialog: false,
    };

    this.schema = Joi.object().keys({
      print_total_manual_operation: Joi.number()
        .max(1)
        .required(),
      total_workers_num: Joi.string()
        .max(19)
        .label('total_operator')
        .regex(regex.pattern.total_operator)
        .required(),
    });
  }

  componentDidMount() {
    this.setField(() => {});
  }

  setField() {
    let id = this.state.fieldId;
    let formValues = { ...this.state.formValues };
    FieldService.info(id, {}).then(resp => {
      if (resp.result) {
        formValues.print_total_manual_operation =
          resp.data.entities.field.print_total_manual_operation;
        formValues.total_workers_num = String(
          resp.data.entities.field.total_workers_num
        );
        this.setState({ formValues });
      }
    });
  }

  onChangeEditFlag(checked) {
    const formValues = this.state.formValues;
    if (checked) {
      formValues.print_total_manual_operation = 0;
    } else if (!checked) {
      formValues.print_total_manual_operation = 1;
    }
    this.setState({ formValues });
  }

  onChangeEditNum(e) {
    const formValues = this.state.formValues;
    formValues[e.target.name] = e.target.value;
    this.setState({ formValues });
  }

  //バリデーション
  validate(events) {
    const errors = this.state.errors;

    //単数or複数判定
    if (events) {
      const result = validationByJoi(this.schema, this.state.formValues);
      const targetName = events.target.name;
      const targetValue = events.target.value;
      if (result.messages[targetName]) {
        errors[targetName] = result.messages[targetName];
      } else if (targetValue.match(/^(0[0-9]{1,})$/)) {
        // 0から始まる2桁以上の数値はエラーとする
        errors[targetName] = messageUtility.getMessage('E-000-040');
      } else if (errors[targetName]) {
        delete errors[targetName];
      }
      this.setState(errors);
    }

    return Object.keys(errors).length;
  }

  updateTotalizeInfo() {
    if (this.validate() !== 0) {
      return;
    }
    let id = this.state.fieldId;
    const params = {
      print_total_manual_operation: this.state.formValues
        .print_total_manual_operation,
      total_workers_num: this.state.formValues.total_workers_num.toString(),
    };
    FieldService.totalWorkersNumsUpdate(id, params).then(resp => {
      if (resp.result) {
        this.updateDialog();
        this.setState({ errors: {} });
      }
    });
  }

  updateDialog() {
    dialogLoader.show(EditSuccess);
  }

  render() {
    return (
      <div id='main__body1' className='setting-main__body'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 作業員集計設定</title>
        </Helmet>
        <div id='setting-header' className='approval-setting-header'>
          <div className='approval-setting-header__item'>
            <button
              className='btn--effective'
              onClick={() => this.updateTotalizeInfo()}
            >
              更新する
            </button>
          </div>
        </div>
        <div className='setting-main__table'>
          <table id='table' className='setting-table worker-date-setting-table'>
            <thead
              id='table-label'
              className='setting-table__header'
              style={{ position: 'relative', top: 'auto', width: 'auto' }}
            >
              <tr className='setting-table__label'>
                <td className='value-table' colSpan='2'>
                  ここでの設定は以下帳票の「延労働者数」に反映されます。作業間連絡及び調整実施記録（安全衛生日誌有）/安全衛生日誌
                </td>
              </tr>
            </thead>
            <tbody id='table-body'>
              <tr className='setting-table__item '>
                <td className='value-table worker-date-setting-value-table__label'>
                  帳票の累計欄を空白にする
                </td>
                <td className='value-table worker-date-setting-value-table__element'>
                  <label htmlFor='check' className='toggle-radius'>
                    <input
                      type='checkbox'
                      id='check'
                      name='print_total_manual_operation'
                      checked={
                        this.state.formValues.print_total_manual_operation === 1
                          ? 'checked'
                          : ''
                      }
                      onChange={() =>
                        this.onChangeEditFlag(
                          this.state.formValues.print_total_manual_operation ===
                            1
                            ? 'checked'
                            : ''
                        )
                      }
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                  </label>
                </td>
              </tr>
              <tr className='setting-table__item '>
                <td className='value-table worker-date-setting-value-table__label'>
                  <div className='value-table__txt--10'>作業員数累計</div>
                </td>
                <td className='value-table worker-date-setting-value-table__element'>
                  <input
                    type='text'
                    name='total_workers_num'
                    className='--col-xl-8 --col-lg-8 --col-md-12 --col-xs-12'
                    value={this.state.formValues.total_workers_num}
                    onChange={e => this.onChangeEditNum(e)}
                    onBlur={e => this.validate(e)}
                  />
                  {getErrorMessage(this.state.errors, 'total_workers_num')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const getErrorMessage = (errors, column) => {
  if (errors[column]) {
    return <div className='validate-message show'>{errors[column]}</div>;
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/pages/TotalizeInfo.jsx